import { render, staticRenderFns } from "./ProductCategories.vue?vue&type=template&id=ae251054"
import script from "./ProductCategories.vue?vue&type=script&lang=js"
export * from "./ProductCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports